class ContactPoint {
    public Id: string;
    public Version: number;
    public IsPreferred: boolean;
    public IsReachable: boolean;
    public ContactPointTypeLookupId: string;
    public ContactId: string;
    public SiteId: string;
    public CreationDate: Date;
    public CreatedBy: string;
    public LastUpdateDate: Date;
    public LastUpdatedBy: string;
    public DeletionDate: Date;
    public DeletedBy: string;
    public ArchivalDate: Date;
    public ArchivedBy: string;
    public NotificationsEnabled: boolean;

    constructor(init?: Partial<ContactPoint>) {
        Object.assign(this, init);
    }
}

export { ContactPoint };
